// Frank Keyner Portfolio - Public JavaScript

// Video iframe responsive sizing
document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.projects.view iframe.video')

  videos.forEach((video) => {
    const ratio = parseFloat(video.dataset.ratio) || 16 / 9

    const resize = () => {
      const width = video.offsetWidth
      video.style.height = `${Math.round(width / ratio)}px`
    }

    resize()
    window.addEventListener('resize', resize)
  })
})
